export default [
    {
        path: '/parts',
        name: 'Company / Parts',
        component: () => import('@/views/pages/parts'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: 'stocks',
                name: 'Company / Parts / Stocks',
                component: () => import('@/views/pages/parts'),
                meta:
                {
                    page: 'stocks',
                },
            },
            {
                path: 'sales',
                name: 'Company / Parts / Sales',
                component: () => import('@/views/pages/parts'),
                meta:
                {
                    page: 'sales',
                },
            },
            {
                path: 'create',
                name: 'Company / Create Part',
                component: () => import('@/views/pages/parts'),
                meta:
                {
                    page: 'create',
                    subPage: 'main',
                },
            },
            {
                path: ':code',
                name: 'Company / View Part',
                component: () => import('@/views/pages/parts'),
                meta:
                {
                    page: 'view',
                },
                children:
                [
                    {
                        path: 'edit',
                        name: 'Company / Edit Part',
                        component: () => import('@/views/pages/parts'),
                        meta:
                        {
                            page: 'edit',
                            subPage: 'main',
                        },
                    },
                ],
            },
        ],
    },
];